function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import useNavigationList from "./useNavigationList";
import useNavigationListItem from "./useNavigationListItem";
const ACTIONS = [
    "OPEN"
];
const NavigationButtonInner = ({ uuid , children  })=>{
    const navigationListItemProvided = useNavigationListItem(uuid, useMemo(()=>({
            object: {
                __typename: "__Placeholder",
                nodeId: uuid,
                id: uuid
            }
        }), [
        uuid
    ]));
    const { navProps , helpers  } = navigationListItemProvided;
    return /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
        children: children(helpers)
    }));
};
const NavigationButton = ({ uuid , onOpen , children  })=>{
    const { Provider , navProps  } = useNavigationList(uuid, useMemo(()=>({
            actions: ACTIONS,
            performSingularAction (command, activeItem) {
                if (command === "OPEN" && activeItem != null && activeItem.nodeId === uuid) {
                    onOpen();
                    return true;
                }
                return false;
            }
        }), [
        onOpen,
        uuid
    ]));
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
            children: /*#__PURE__*/ _jsx(NavigationButtonInner, {
                uuid: uuid,
                children: children
            })
        }))
    });
};
export default NavigationButton;
